<script setup>
import { storeToRefs } from "pinia";

const config = useRuntimeConfig();
const constants = useConstants();
const route = useRoute();

function stripHtml(input) {
  if (!input) return "";
  return String(input)
    .replace(/<[^>]*>/g, "")
    .trim();
}

const wcagStore = useWcagStore();
const pagesStore = usePagesStore();
const {
  title,
  titlePage,
  text,
  blocks,
  seoTitle,
  seoDescription,
  seoImage,
  slug,
  fullPath,
} = storeToRefs(pagesStore);
const { score, results, totals, url, email, status } = storeToRefs(wcagStore);

const uuid = `${crypto.randomUUID()}`;

const performAudit = async function () {
  try {
    const meta = toRaw(wcagStore.meta);

    const response = await fetch("/api/audit/wcag", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        url: wcagStore.url,
        email: wcagStore.email,
        filename: uuid + ".txt",
        hasAccessibilityStatement: meta.hasAccessibilityStatement,
        isRecentlyAudited: meta.isRecentlyAudited,
        hasPlannedAudit: meta.hasPlannedAudit,
        type: meta.type,
      }),
    });

    const data = await response.json();

    wcagStore.setResults(data?.body?.results);
    wcagStore.setTotals(data?.body?.totals);
    wcagStore.setScore(data?.body?.meta);
    wcagStore.setAudited();

    return data;
  } catch (error) {
    throw createError(error);
  }
};
// const storeAudit = async function () {
//   console.log("storeAudit gestart");

//   let content = "";
//   try {
//     content = JSON.stringify(
//       {
//         email: email.value ?? null,
//         score: score.value ?? null,
//         totals: totals.value ?? {},
//         results: results.value ?? {},
//         meta: toRaw(wcagStore.meta) ?? {},
//       },
//       null,
//       2
//     );
//     // content = JSON.stringify({}, null, 2);
//   } catch (err) {
//     console.error("storeAudit: JSON.stringify faalt!", err);
//     throw createError({
//       statusCode: 500,
//       statusMessage: "Serialisatie van audit-resultaat faalt",
//     });
//   }
//   console.log(content);

//   try {
//     console.log("storeAudit: start upload", {
//       filename: uuid + ".txt",
//       length: content.length,
//     });

//     const result = await $fetch("/api/audit/upload", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         filename: uuid + ".txt",
//         content: JSON.stringify({
//           email: wcagStore.email,
//         }),
//       }),
//     });

//     console.log("Upload succesvol:", result);
//     return result;
//   } catch (error) {
//     console.error("storeAudit upload faalt:", error);
//     console.dir(error, { depth: 5 });
//     throw createError(error);
//   }
// };
const createEntry = async function () {
  const urlValue = url.value;
  const emailValue = email.value;

  const body = JSON.stringify({
    uuid,
    urlValue,
    emailValue,
  });

  try {
    return await fetch(config?.public?.apiBaseUrl + "/create-wcag-entry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });
  } catch (error) {
    throw createError(error);
  }
};
const sendEmail = async function () {
  const urlValue = url.value;
  const emailValue = email.value;

  try {
    return await fetch(config?.public?.apiBaseUrl + "/send-wcag-mail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: emailValue,
        uuid: uuid,
        url: urlValue,
      }),
    });
  } catch (error) {
    throw createError(error);
  }
};

const audit = async function () {
  await performAudit();
  // await storeAudit();
  await createEntry();
  await sendEmail();

  try {
    await navigateTo("/wcag/analyse-toegankelijkheid");
  } catch (error) {
    throw createError(error);
  }
};

await $fetch(
  "/api/pages/" + route?.params?.slugs[route?.params?.slugs.length - 1]
)
  .then(function (response) {
    pagesStore.current = response;
  })
  .catch(function (error) {
    throw createError(error);
  });

definePageMeta({
  layout: "default",
});
useHead({
  title:
    stripHtml(seoTitle?.value || titlePage?.value || title?.value || "") +
    constants.app.title,
  link: [
    {
      rel: "canonical",
      href: fullPath,
    },
  ],
});
useSeoMeta({
  title:
    stripHtml(seoTitle?.value || titlePage?.value || title?.value || "") +
    constants.app.title,
  description: seoDescription?.value ?? null,
  image: seoImage?.value ?? null,
  ogSiteName: constants.app.siteName,
  ogType: "website",
  ogTitle:
    stripHtml(seoTitle?.value || titlePage?.value || title?.value || "") +
    constants.app.title,
  ogDescription: seoDescription?.value ?? null,
  ogImage: seoImage?.value ?? null,
  ogUrl: fullPath ?? null,
  ogArticlePublisher: constants.app.social.facebook,
  twitterTitle:
    (seoTitle?.value ?? titlePage?.value ?? title.value ?? "") +
    constants.app.title,
  twitterDescription: seoDescription?.value ?? null,
  twitterImage: seoImage?.value ?? null,
});
</script>
<template>
  <div>
    <Hero :title="titlePage ?? title ?? ''" :text="text" />
    <Blocks :blocks="blocks" @startScan="audit" />
  </div>
</template>

<style>
.p-section {
  p {
    a {
      text-decoration: underline;
      cursor: pointer;
      color: rgb(249 229 157 / var(--tw-text-opacity, 1));
      font-weight: 700;
    }
  }
}
</style>
